module.exports = __webpack_public_path__ + "img/@tmp_hrdcloud_02.36c1a5a8.jpg";